// extracted by mini-css-extract-plugin
export default {"root":"_3RVSwz7L","logo":"_1N6CPspF","button":"TZdhPGGG"};